import Loadable from 'react-loadable';

const TopicPage = Loadable({
  loader: () => import(/* webpackChunkName: "TagPage" */ './TopicPage'),
  loading: () => null,
});

export default TopicPage;
